<template>
  <div class="sm:mt-8 mt-4 overflow-hidden xl:mt-0 py-10">
    <div class="mx-auto sm:px-7 px-4 dark:text-white max-w-screen-xl">
      <div class="grid items-center gap-4 lg:gap-8 lg:grid-cols-2">
        <div class="text-center lg:text-left">
          <div class="flex items-center justify-center p-2 lg:justify-start lg:flex-row flex-col lg:gap-0 gap-4">
            <IdeasIcon class="w-10" />
            <span class="ml-2 text-lg sm:text-xl text-grow">{{ dataLocale.data.tag }}</span>
          </div>
          <h1 class="mt-8 text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-medium">
            QR Code <span class="text-success">Generator</span>
          </h1>
          <p class="mt-4 text-lg sm:text-xl text-grow">
            {{ dataLocale.data.p1 }}
          </p>
          <p class="mt-2 text-lg sm:text-xl text-grow">
            {{ dataLocale.data.p2 }}
          </p>
          <div class="flex mt-8 justify-center lg:justify-start xs:flex-row flex-col gap-4">
            <a :href="useRuntimeConfig().public.app_user_url" target="_blank" rel="noopener noreferrer"
              class=" h-12 px-5 font-semibold bg-success text-white whitespace-nowrap transition inline-flex items-center justify-center rounded-full">
              <SmallIcon class="text-white mr-1" /> {{ $t('start_for_free') }}
            </a>
            <nuxt-link to="/contact-us"
              class=" h-12 px-5 box-border border bg-white font-bold whitespace-nowrap transition focus:outline-none inline-flex items-center justify-center rounded-full">
              {{ $t('contact_sales') }}
            </nuxt-link>
          </div>
        </div>
        <div class="h-full flex items-center justify-center px-10 lg:w-full sm:max-w-xl max-w-xs mx-auto">
          <nuxt-img loading="lazy" src="/home/mb.png" format="webp" alt="qr-code-generator" title="QR Code Generator" :width="820" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SmallIcon from "~/assets/svg/homepage/small.svg?component";
import IdeasIcon from "~/assets/svg/homepage/ideas.svg?component";
import DataLocale from "~~/config/interface/DataLocale";

const dataLocale = new DataLocale([
  {
    locale: "en",
    tag: "The key to connecting with customers",
    p1: " Boost your targeted customer reach and increase efficiency for your business with easy and lightning-fast QR code usage!",
    p2: "Don't miss the opportunity to take your business to a more innovative and convenient future."
  },
  {
    "locale": "vi",
    "tag": "Chìa khóa kết nối với khách hàng",
    "p1": "Tăng độ phủ khách hàng mục tiêu và tăng hiệu quả cho doanh nghiệp của bạn với việc sử dụng mã QR dễ dàng và nhanh chóng!",
    "p2": "Đừng bỏ lỡ cơ hội để đưa doanh nghiệp của bạn tới một tương lai sáng tạo và tiện lợi hơn."
  }
  ,
  {
    "locale": "fr",
    "tag": "La clé pour se connecter avec les clients",
    "p1": "Augmentez votre portée de clientèle ciblée et augmentez l'efficacité de votre entreprise avec une utilisation facile et ultra-rapide de codes QR !",
    "p2": "Ne manquez pas l'occasion de faire passer votre entreprise vers un avenir plus innovant et pratique."
  }
  ,
  {
    "locale": "es",
    "tag": "La clave para conectarse con los clientes",
    "p1": "¡Mejore su alcance de clientes objetivos y aumente la eficiencia de su negocio con el uso fácil y ultra rápido de códigos QR!",
    "p2": "No pierda la oportunidad de llevar su negocio hacia un futuro más innovador y conveniente."
  }
  ,
  {
    "locale": "it",
    "tag": "La chiave per connettersi con i clienti",
    "p1": "Aumenta il tuo raggio d'azione verso i clienti target e aumenta l'efficienza per la tua attività commerciale con l'uso facile e ultraveloce dei codici QR!",
    "p2": "Non perdere l'opportunità di portare la tua attività verso un futuro più innovativo e conveniente."
  }
  ,
  {
    "locale": "ja",
    "tag": "お客様とのつながりのカギ",
    "p1": "簡単かつ超高速なQRコードの利用により、ターゲット顧客の到達範囲を拡大し、ビジネスの効率を向上させましょう！",
    "p2": "ビジネスをより革新的で便利な未来に導くチャンスをお見逃しなく。"
  }
  ,
  {
    "locale": "de",
    "tag": "Der Schlüssel zur Verbindung mit Kunden",
    "p1": "Erweitern Sie Ihre gezielte Kundenreichweite und steigern Sie die Effizienz Ihres Geschäfts mit einfacher und blitzschneller QR-Code-Nutzung!",
    "p2": "Verpassen Sie nicht die Chance, Ihr Geschäft in eine innovativere und bequemere Zukunft zu führen."
  },
  {
    locale: "zh",
    tag: "与客户建立联系的关键",
    p1: "通过简单且快速的QR码使用，提高针对性客户的覆盖范围，增加业务效率！",
    p2: "不要错过将您的业务带入更具创新和便利的未来的机会。"
  },
  {
    locale: "pt",
    tag: "A chave para se conectar com os clientes",
    p1: " Aumente o alcance do seu público-alvo e aumente a eficiência da sua empresa com o uso fácil e rápido de códigos QR!",
    p2: "Não perca a oportunidade de levar seu negócio a um futuro mais inovador e conveniente."
  }
])
</script>
